<template>
  <el-select
    :value="value"
    @input="change"
    clearable
    placeholder="请选择业态类型">
    <el-option
      v-for="item in projectBusinesses"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    props:['value'],
    computed:{
      ...mapGetters('decision',{
        projectBusinesses:'selectProjectBusinessArr'
      })
    },
    created() {
      this.$store.dispatch('decision/getProjectBusiness')
    },
    mounted() {
      
    },
    methods: {
      change(value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>